import type { Action } from '~/authorizations';

export type TabActionGate = 'pending' | 'blocked' | 'allowed';

/**
 * Whether a tab that needs `action` may render. Stays `pending` until the project's own org has loaded,
 * since until then the role in the store can belong to the previously selected org.
 */
export function getTabActionGate(params: {
  orgReady: boolean;
  action: Action | undefined;
  can: (action: Action) => boolean;
}): TabActionGate {
  const { orgReady, action, can } = params;
  if (!action) return 'allowed';
  if (!orgReady) return 'pending';
  return can(action) ? 'allowed' : 'blocked';
}
